const initKavoLifestyleGrids = (scope = document) => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  scope.querySelectorAll('[data-kavo-lifestyle-grid]:not([data-grid-ready])').forEach((grid) => {
    grid.dataset.gridReady = 'true';
    const videos = [...grid.querySelectorAll('video')];
    if (reduceMotion) {
      videos.forEach((video) => video.pause());
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) video.play().catch(() => {});
        else video.pause();
      });
    }, { rootMargin: '180px 0px', threshold: .08 });
    videos.forEach((video) => observer.observe(video));
  });
};
document.addEventListener('DOMContentLoaded', () => initKavoLifestyleGrids());
document.addEventListener('shopify:section:load', (event) => initKavoLifestyleGrids(event.target));
